module.exports = __webpack_public_path__ + "img/webcam.123e5562.png";